import React, { Component } from 'react';
import './App.css';

class Tabs extends Component {

  getClass(query) {
    if(this.props.active === query){
      return("site-header__tabs__tab is-active");
    }
    else {
      return("site-header__tabs__tab");
    }
  }

  removeExtra(content) {
    if(content.length > 10) {
      var short = content.substring(0,9);
      short += '..';
      return short;
    }
    else {
      return content;
    }
  }

  removeMoreExtra(content) {
    if(content.length > 10) {
      var short = content.substring(0,5);
      short += '..';
      return short;
    }
    else {
      return content;
    }
  }

  render() {
    if(this.props.tabs.length > 1 && this.props.tabs.length <= 3){
      const res = this.props.tabs.map((content, i) =>
        (
          <li key={i} className={this.getClass(content)}>
            <span className='tab-title' onClick={this.props.show.bind(this, content)}>{this.removeExtra(content)}</span>
            <span className='tab-remove' onClick={this.props.removeTab.bind(this, content)}>&times;</span>
          </li>
        ));
      return(
        <div className="site-header__tabs">
          <ul>
            {res}
          </ul>
        </div>
      );
    }
    else if(this.props.tabs.length > 3){
      const res = this.props.tabs.map((content, i) =>
        (
          <li key={i} className={this.getClass(content)}>
            <span className='tab-title' onClick={this.props.show.bind(this, content)}>{this.removeMoreExtra(content)}</span>
            <span className='tab-remove' onClick={this.props.removeTab.bind(this, content)}>&times;</span>
          </li>
        ));
      return(
        <div className="site-header__tabs">
          <ul>
            {res}
          </ul>
        </div>
      );
    }
    else{
      return(
        <div className="site-header__tabs">
          <ul>
            <li className="site-header__tabs__tab is-active">
              <span className='tab-title'>{this.props.tabs[0]}</span>
            </li>
          </ul>
        </div>
      );
    }
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./client/src/Tabs.js